<div class="container">

  <div class="row no-gutters mt-5">
    <div class="col-12 ">
      <div class="alert alert-warning" role="alert">
        <h3>404</h3>
        <p>Page not found.</p>
        <p>Please contact the administrator.</p>
      </div>
    </div>
  </div>

</div>
